export enum ButtonSize {
  SMALL = 'small',
  LARGE = 'large',
}
